<template>
    <div>
      <div class="orderinfoTopcentertwo">
          <dl>
          <dt style="float:left;"><img :src="content.productPic" alt=""></dt>
          <dd>
              <div class="orderinfoTopcentertwodd" style="display:flex;justify-content:space-between;color:#333333;">
              <div>
                  <span style="padding-left:5px;" class="ellpis">{{content.productName}}</span>
              </div>
              </div>
              <div class="orderinfoTopcentertwoddTwo">{{content.productAttr}}</div>
          </dd>
          </dl>
          <div style="margin:15px 5px; display:flex;justify-content:flex-start;">
              <div class="pf">评分</div> <van-rate v-model="value" size='20px' />
          </div>
          <div style="width:96%;margin:0 auto;border:0.5px solid #ccc;border-bottom:0.5px solid #ccc;">
              <van-field
                  v-model="message"
                  rows="5"
                  autosize
                  type="textarea"
                  maxlength="200"
                  placeholder="说说值得推荐的理由吧"
                  show-word-limit
              />
          </div>
          <p style="margin:10px">上传图片(最多4张)</p>
          <div style="margin-top:20px;width:96%;margin:0 auto;display: flex;justify-content: flex-start;">
            <!-- <div class="posting-uploader-item" v-for="(item,index) in postData" :key="index">
              <img :src="item"  alt="图片" class="imgPreview" @click="ImagePreviewClick(index)">
              <van-icon name="close" @click="delImg(index)" class="delte"/>
            </div> -->
            <!-- <van-uploader :max-count="4" :after-read="afterRead"  v-show="show" /> -->
              <van-uploader :max-count="4" @delete="beforedelete" v-model="fileList" :after-read="afterRead" />
          </div>
      </div>
        <van-button type="primary" @click="over" block>提交</van-button>
    </div>
</template>
<script>
import { compressImage } from './compressImage.js'

import { Rate, Field, Uploader, Button, Icon, Toast, Dialog, ImagePreview } from 'vant'
import { ordereval } from '../../request/api.js'
// var a = 0
export default {
  components: {
    [Rate.name]: Rate,
    [Field.name]: Field,
    [Uploader.name]: Uploader,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [ImagePreview.name]: ImagePreview
  },
  data () {
    return {
      content: {},
      value: 5,
      message: '',
      name: '',
      arr: [],
      postData: [],
      show: true,
      fileList: [],
      time: ''
    }
  },
  methods: {
    // 删除图片
    beforedelete(file, detail) {
      this.postData.splice(detail.index, 1)
      // this.fileList.splice(detail.index, 1)
      console.log(this.postData)
      console.log(this.fileList)
    },
    beforeRead(file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        Toast('请上传 jpg或png 格式的图片')
        return false
      }
      return true
    },
    // ImagePreviewClick(index) {
    //   ImagePreview({
    //     images: this.postData,
    //     closeOnPopstate: true,
    //     startPosition: index
    //   })
    // },
    afterRead (file, detail) {
      const ua = navigator.userAgent.toLowerCase()
      // Android终端
      const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
      // Ios终端
      const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      console.log(isiOS, isAndroid)
      // if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      //   // kInputFromiOS('login')
      // } else if (/(Android)/i.test(navigator.userAgent)) {
      //   console.log('传递参数安卓')
      //   var message = {
      //     body: 'camera'
      //   }
      //   var jsonStr = JSON.stringify(message)
      //   window.android.getDataFormVue(jsonStr)
      // }
      var that = this
      console.log(file)
      const OSS = require('ali-oss')
      // base64格式的图片文件
      const urlData = file.content
      // console.log(urlData)
      compressImage(urlData, {
        width: 200,
        quality: 0.7
      }).then(result => {
        // console.log(result)
        return result
      }).then(res => {
        const base64 = res.split(',').pop()

        const fileType = res
          .split(';')
          .shift()
          .split(':')
          .pop()
        function toBlob (res, fileType) {
          const bytes = window.atob(res)
          let n = bytes.length
          const u8arr = new Uint8Array(n)
          while (n--) {
            u8arr[n] = bytes.charCodeAt(n)
          }
          return new Blob([u8arr], { type: fileType })
        }
        // console.log(fileType)
        // base64转blob
        const blob = toBlob(base64, fileType)
        // blob转arrayBuffer
        const reader = new FileReader()
        reader.readAsArrayBuffer(blob)
        reader.onload = function (event) {
          console.log(event)
          const client = new OSS({
            region: 'oss-cn-beijing',
            endpoint: 'vue.soujingpin.com',
            accessKeyId: 'LTAI4FoC2pB7aGMSbj6WFith',
            accessKeySecret: 'sETV8g6QhzNj87ebibWEkzxNf2tMvr',
            bucket: 'soujingpin-vue-3fang',
            cname: true
          })
          // console.log(client)
          // 文件名:图片名字加上时间戳和9999以内随机数，防止重名
          const objectKey = `/gjdw/${new Date().getTime()}${Math.floor(
            Math.random() * 10000
          )}${file.file.name}`
          // arrayBuffer转Buffer
          const buffer = new OSS.Buffer(event.target.result)
          // 上传
          client
            .put(objectKey, buffer)
            .then(function (result) {
              // // console.log(result)
              // a++
              // if (a === 4) {
              //   that.show = false
              // }
              that.postData.push(result.url) // 上传一张之后压入这个数组
              // for (var i = 0; i < 5; i++) {
              //   if (a === i) {
              //     that.arr.push(result.url)
              //     console.log(that.arr)
              //   }
              // }
            })
            .catch(function (err) {
              console.log('cuowu', err)
              Toast('上传图片失败')
            })
        // console.log(that.arr)
        }
      })
    },
    onChange (value) {
      console.log(value)
    },
    over () {
      console.log(this.value)
      this.time = setTimeout(() => {
        if (this.postData.length === 0) {
          console.log('走这里')
          console.log(this.content)
          var params
          params = {
            id: this.$route.query.id,
            content: this.message,
            pics: '',
            star: this.value,
            orderItemId: this.content.id
          }
        } else {
          console.log('走哪里了')
          params = {
            id: this.$route.query.id,
            content: this.message,
            pics: this.postData.join(','),
            star: this.value,
            orderItemId: this.content.id
          }
        }
        console.log(params)
        ordereval(params.id, params).then(res => {
          console.log(res)
          if (res.code === 200) {
            Toast.success('评论成功')
            this.$router.go(-1)
          }
        }).catch(res => {
          console.log(res)
        })
      }, 800)
    }
  },
  beforeDestroy() {
    clearTimeout(this.time)
  },
  created () {
    this.content = JSON.parse(this.$route.query.content)
    // this.id = JSON.parse(this.$route.query.content.id)
    console.log(JSON.parse(this.$route.query.content))
    // console.log(JSON.parse(this.$route.query.content[0].id))
  }
}
</script>
<style lang="less" scoped>
    .orderinfoTopcentertwo {
        width: 96%;
        margin: 0 auto;
      dl{
          padding-top: 20px;
          height: 160px;
        dt{
          width: 150px;
          height: 150px;
          img{
            width: 100%;
            height: 100%;
          }
        }
        dd{
          margin-left: 170px;
          .orderinfoTopcentertwodd{
            font-size: 28px;
          }
          .orderinfoTopcentertwoddTwo{
            font-size: 24px;
            color: #999999;
            padding-left: 10px;
            padding-top: 10px;
          }
          .orderinfoTopcentertwoddThree{
            margin-top: 10px;
            display: flex;
            justify-content: flex-start;
            div{
              font-size: 30px;
              margin-right: 40px;
            }
            s{
              font-size: 27px;
              padding-top: 5px;
            }
          }
        }
      }
    }
    /deep/ .van-uploader__preview {
        width: 150px;
        height: 150px;
        .van-uploader__preview-image{
            width: 100%;
            height: 100%;
        }
    }
    /deep/ .van-uploader__upload{
        width: 150px;
        height: 150px;
    }
    /deep/ .van-uploader__preview-delete{
        font-size: 35px;
    }
    /deep/ .van-uploader__upload-icon {
        font-size: 50px;
    }
    /deep/ .van-image__error-icon {
        font-size: 50px;
    }
    /deep/.van-button--primary {
        background-color: #B4272D;
        border:#B4272D 1px solid;
        position: absolute;
        bottom: 0px;
        height: 70px;
        font-size: 28px;
    }
    .posting-uploader-item {
      width: 150px;
      height: 150px;
      position: relative;
      margin-right: 20px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .pf{
      font-size: 26px;
      margin-right: 20px;
    }
    /deep/ .van-field__control{
      font-size: 25px;
    }
    /deep/ .delte{
      position: absolute;
      top: -15px;
      right: -10px;
      z-index: 999;
    }
    /deep/ .van-uploader{
      margin-left: 10px;
    }
    /deep/ .van-field__word-limit{
      font-size: 26px;
      line-height: 30px;
    }
    /deep/ .van-uploader__preview{
      margin-right: 15px;
    }
</style>
